module.exports = __webpack_public_path__ + "img/VL_10_01.2bb1155e.png";